module.exports = __webpack_public_path__ + "img/login-bg.90027202.jpeg";